import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzEaster75 } from './pages'

type TIdToPageMapWoofzLove = Record<PageIdWoofzEaster75, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_EASTER_75: TIdToPageMapWoofzLove = {
  [PageId.SUBSCRIPTIONS_EASTER_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_75/pages/subscriptions/SubscriptionEaster75'
      ).then((m) => ({
        default: m.SubscriptionsEaster75,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_75/pages/subscriptions/SubscriptionEaster75'
      ),
  },
  [PageId.CHAT_UPSELL_EASTER_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_75/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_75/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_EASTER_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_75/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_easter/woofz_easter_75/pages/upsell/Upsell'),
  },
  [PageIdWoofzEaster75.DOWNLOAD_EASTER_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_75/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_75/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzEaster75.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
